import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-google-auth-presentation',
  templateUrl: './google-auth-presentation.component.html',
  styleUrls: ['./google-auth-presentation.component.scss'],
})
export class GoogleAuthPresentationComponent {
  @Output() public emitGoogleSignIn = new EventEmitter<void>();

  public signInWithGoogleClick(): void {
    this.emitGoogleSignIn.emit();
  }
}
